import { isProduction, isStaging } from "./env";

export const favicon = isProduction ? "/favicon.ico" : isStaging ? "/favicon-stage.ico" : "/favicon-dev.ico";
